// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 1rem;
}

.demo {
  height: 100px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}
.demo > * {
  position: relative;
  padding: 3rem 3rem 2rem 3rem;
  border: 1px solid var(--gc-border-color);
}
.demo > * > .title {
  position: absolute;
  top: -1px;
  left: -1px;
  border: 1px solid var(--gc-border-color);
  padding: 0.25rem;
}
.demo .light {
  background: rgb(249, 249, 249);
  color: rgb(18, 18, 18);
}
.demo .dark {
  background: rgb(18, 18, 18);
  color: rgb(255, 255, 255);
}
.demo .color {
  height: 100%;
  border-radius: 4px;
}

.user {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}
.user .avatar {
  display: inline-flex;
  background: var(--color);
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  font-size: 1rem;
  border-radius: 50%;
  overflow: hidden;
  font-size: 1rem;
  position: relative;
}
.user .avatar .color-overlay {
  background: var(--color);
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  mix-blend-mode: lighten;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}
.user .color {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/steppers/users/steps/photo/photo.step.sass"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AAAJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AACJ;AAAI;EACI,kBAAA;EACA,4BAAA;EACA,wCAAA;AAER;AADQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wCAAA;EACA,gBAAA;AAGZ;AAFI;EACI,8BAAA;EACA,sBAAA;AAIR;AAHI;EACI,2BAAA;EACA,yBAAA;AAKR;AAJI;EACI,YAAA;EACA,kBAAA;AAMR;;AAJA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AAOJ;AANI;EACI,oBAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAQR;AAPQ;EACI,wBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AASZ;AAPI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AASR","sourcesContent":["\n.page\n    display: grid\n    grid-template-columns: 1fr 1fr\n    gap: 1rem\n    padding: 1rem\n    \n.demo\n    height: 100px\n    display: grid\n    grid-template-columns: repeat(2, 1fr)\n    gap: 1rem\n    > * \n        position: relative\n        padding: 3rem 3rem 2rem 3rem\n        border: 1px solid var(--gc-border-color)\n        > .title\n            position: absolute\n            top: -1px\n            left: -1px\n            border: 1px solid var(--gc-border-color)\n            padding: 0.25rem\n    .light\n        background: rgb(249, 249, 249)\n        color: rgb(18, 18, 18)\n    .dark\n        background: rgb(18, 18, 18)\n        color: rgb(255, 255, 255)\n    .color\n        height: 100%\n        border-radius: 4px\n\n.user \n    display: flex\n    gap: 0.5rem\n    align-items: center\n    user-select: none\n    pointer-events: none\n    .avatar\n        display: inline-flex\n        background: var(--color)\n        align-items: center\n        justify-content: center\n        width: 2rem\n        height: 2rem\n        font-size: 1rem\n        border-radius: 50%\n        overflow: hidden\n        font-size: 1rem\n        position: relative\n        .color-overlay\n            background: var(--color)\n            width: 100%\n            height: 100%\n            display: block\n            position: absolute\n            mix-blend-mode: lighten\n            user-select: none\n            pointer-events: none\n\n    .color\n        width: 1rem\n        height: 1rem\n        border-radius: 50%\n        display: block"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
